'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

import {
  extractPaymentFailInfoFromSearchParams,
  stripPaymentReturnSearchParams,
} from '@/features/cloudpayments/utils';
import { showCloudPaymentsFailInfoToast } from '@/features/cloudpayments/utils/showCloudPaymentsWarningToast.util';

export const useCloudPaymentsPaymentReturnToast = (): void => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (searchParams.get('payment') !== 'fail') {
      return;
    }

    const failInfo = extractPaymentFailInfoFromSearchParams(searchParams);
    showCloudPaymentsFailInfoToast(failInfo);

    const cleanedParams = stripPaymentReturnSearchParams(
      new URLSearchParams(searchParams.toString()),
    );
    const nextUrl = cleanedParams.toString() ? `${pathname}?${cleanedParams.toString()}` : pathname;

    window.history.replaceState(null, '', nextUrl);
  }, [pathname, searchParams]);
};
